import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import api from "../../api/axiosInstance";
const FormsSubmitted = ({ }) => {
  const [submittedForms, setSubmittedForms] = useState([]);

const userData = JSON.parse(localStorage.getItem('user')); // Get user info from localStorage
const userId = userData ? userData.id : null; // Get logged-in user email
const jobCategoryId = userData ? userData.jobCategoryId : null; // Get logged-in user email

  useEffect(() => {
    api
      .get(`/Form/GetFormsSubmittedToMe?contactId=${userId}&jobCategoryId=${jobCategoryId}`)
      .then((res) =>
        setSubmittedForms(res.data)) 
      .catch((err) => console.error("Error fetching submitted forms:", err));
  }, [userId, jobCategoryId]);



  const handleViewForm = (formId) => {
    window.open(`/form-preview/${formId}`, "_blank");
  };

        useEffect(() => {
            console.log(submittedForms);
          debugger;
    if (submittedForms.length > 0) {
      setTimeout(() => {
        if (window.$ && window.$.fn.DataTable) {
          window.$("#example1").DataTable({
            responsive: true,
            autoWidth: false,
            searching: true,
            ordering: true,
            pageLength: 10,
            lengthChange: false,
            paging: true,
            info: true,
            destroy: true, // Prevent duplication
          });
        }
      }, 300); // Slight delay to ensure table is in the DOM
    }
  }, [submittedForms]); // Runs when `forms` is updated


    const isValidDate = (date) => {
  if (!date) return false;
  const d = new Date(date);
  if (isNaN(d.getTime())) return false;
  if (d.getFullYear() <= 1) return false; // removes 0001-01-01
  return true;
};

  return (
    <div className="row">
      <div className="col-md-12">
      <div className="card card-success">
        <div className="card-header">
          <h3 className="card-title">📥 Forms Submitted To Me</h3>
        </div>
        <div className="card-body">
          <table id="example1" className="table table-bordered table-striped">
            <thead>
              <tr>
                <th width="42%">Name</th>
                <th width="20%">Form Category</th>
                <th width="20%">Form Sub-Category</th>
                <th width="12%">Submitted On</th>
                <th width="3%">Action</th>
              </tr>
            </thead>
            <tbody>
              {submittedForms.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", color: "gray" }}>
                    No Forms Available
                  </td>
                </tr>
              ) : (
                submittedForms.map((form) => (
                  <tr key={form.id}>
                    <td>{form.name}</td>
                    <td>{form.formCategoryName}</td>
                    <td>{form.formSubCategoryName}</td>
                    <td>{!isValidDate(form.submittedOn) ? '' :new Date(form.submittedOn).toLocaleDateString()}</td>
                    <td>
                      <button
                        className="btn btn-xs btn-success"
                        title="Open in New Tab"
                        onClick={() => handleViewForm(form.id)}
                      >
                        <i className="fa fa-external-link-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
};

export default FormsSubmitted;
  